/* Load Modules */
import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import FormBoxes from "../../../../../../utils/forms/components/FormBoxes";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../store/store";
import { MailSenderConfiguration } from "../../../../reducers/editingConfiguration.reducer";

// Styles
import "./MailSenderConfigurationSection.component.scss";

/* Load Forms */
import { mailSenderConfigBox } from "./FormBuild/MailSenderConfiguratinSection.forms";
import { defaultValues } from "./FormBuild/MailSenderConfiguratinSection.defaults";

import { ConfigurationsActionTypes } from "../../../../actions/actionTypes";

export interface MailSenderConfigurationSectionProps {
    updateMailSenderConfig: ActionCreator;
    mailSenderConfig: MailSenderConfiguration;
    mailSenderSchema: any;
    schemaLoading: boolean;
    editingConfigurationLoading: boolean;
    editingConfiguration: any;
    configSectionVisited: ActionCreator;
}

class MailSenderConfigurationSection extends Component<
    MailSenderConfigurationSectionProps,
    {}
> {
    private previousMainFormValues = null;
    private previousMailFormValues = null;
    private previousKeepingFormValues = null;

    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_MAIL_SENDER_CONFIG
        );
    }

    onMailFormChange = formEvent => {
        this.previousMailFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore(formEvent.values);
    };

    onKeepingFormChange = formEvent => {
        this.previousKeepingFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore(formEvent.values);
    };

    onFormChange = formEvent => {
        this.previousMainFormValues = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };
        this.updateStore(formEvent.values);
    };

    checkIfAllAreValid() {
        return this.previousMailFormValues !== null &&
            this.previousMailFormValues.isValid
            ? true
            : false;

        /*this.previousKeepingFormValues !== null &&
            this.previousKeepingFormValues.isValid &&*/
    }

    updateStore = (formValues = this.props.mailSenderConfig) => {
        if (!formValues) return;

        const values = {
            ...(this.previousMainFormValues
                ? this.previousMainFormValues.values
                : null),
            mail: this.previousMailFormValues
                ? this.previousMailFormValues.values
                : null,
            keeping: this.previousKeepingFormValues
                ? this.previousKeepingFormValues.values
                : null
        };

        this.props.updateMailSenderConfig({
            config: values,
            isValid: this.checkIfAllAreValid()
        });
    };

    render() {
        if (this.props.editingConfigurationLoading) {
            return (
                <div className="loading" key="loading">
                    <Components.LoadingRipple width={100} height={100} />
                </div>
            );
        } else {
            return (
                <div id="MailSenderConfigurationSection">
                    <FormBoxes
                        boxes={mailSenderConfigBox({
                            schema: this.props.mailSenderSchema,
                            mailConfig: this.props.mailSenderConfig
                        })}
                        onChange={this.onFormChange}
                        validateOnUpdate={true}
                        initialValues={
                            this.props.mailSenderConfig
                                ? this.props.mailSenderConfig
                                : defaultValues({
                                      schema: this.props.mailSenderSchema,
                                      form_values: this.props.mailSenderConfig
                                  })
                        }
                    />

                    <div
                        className="inner-card-title"
                        style={{ marginBottom: "20px" }}
                    >
                        Mail Settings
                    </div>
                    <FormBoxes
                        key={`${
                            this.props.mailSenderConfig &&
                            this.props.mailSenderConfig.enabled
                                ? "true"
                                : "false"
                        }-mail`}
                        boxes={mailSenderConfigBox({
                            schema: this.props.mailSenderSchema.definitions
                                .$mail,
                            mailConfig: this.props.mailSenderConfig
                        })}
                        onChange={this.onMailFormChange}
                        validateOnUpdate={true}
                        initialValues={
                            this.props.mailSenderConfig &&
                            this.props.mailSenderConfig.mail
                                ? this.props.mailSenderConfig.mail
                                : defaultValues({
                                      schema: this.props.mailSenderSchema
                                          .definitions.$mail,
                                      form_values:
                                          this.props.mailSenderConfig &&
                                          this.props.mailSenderConfig.mail
                                              ? this.props.mailSenderConfig.mail
                                              : null
                                  })
                        }
                    />

                    {/*<div
                        className="inner-card-title"
                        style={{ marginBottom: "20px" }}
                    >
                        Keeping Settings
                    </div>

                    <FormBoxes
                        boxes={mailSenderConfigBox({
                            schema: this.props.mailSenderSchema.definitions
                                .$keeping,
                            mailConfig: this.props.mailSenderConfig
                        })}
                        key={`${
                            this.props.mailSenderConfig &&
                            this.props.mailSenderConfig.enabled
                                ? "true"
                                : "false"
                        }-keeping`}
                        onChange={this.onKeepingFormChange}
                        validateOnUpdate={true}
                        initialValues={
                            this.props.mailSenderConfig &&
                            this.props.mailSenderConfig.keeping
                                ? this.props.mailSenderConfig.keeping
                                : defaultValues({
                                      schema: this.props.mailSenderSchema
                                          .definitions.$keeping,
                                      form_values:
                                          this.props.mailSenderConfig &&
                                          this.props.mailSenderConfig.keeping
                                              ? this.props.mailSenderConfig
                                                    .keeping
                                              : null
                                  })
                        }
                    />*/}
                </div>
            );
        }
    }
}

const mapDispatchToProps = {
    updateMailSenderConfig: ConfigurationsActionCreators.updateMailSenderConfig,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited
};

const mapStateToProps = state => ({
    mailSenderSchema: configurationsStoreSelectors.mailSenderSchema(state),
    schemaLoading: configurationsStoreSelectors.schemaLoading(state),
    editingConfiguration:
        configurationsStoreSelectors.editingConfiguration(state),
    mailSenderConfig: configurationsStoreSelectors.mailSenderConfig(state),
    editingConfigurationLoading:
        configurationsStoreSelectors.editingConfigurationLoading(state)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MailSenderConfigurationSection);
